import RentalscapeLogo from '@/../img/rentalscape-logo.svg';
import styled from 'styled-components';

const StyledRentalscapeLogo = styled(RentalscapeLogo)`
  width: 28px;
  margin-right: 10px;
`;

const FullPagePlaceholderBackground = styled.div`
  background-color: #f6f9ff;
  height: 100vh;
  width: 100vw;
  position: relative;
`;

const LogoWrapper = styled.div`
  position: absolute;
  left: 26px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  top: 26px;
`;

export { StyledRentalscapeLogo, FullPagePlaceholderBackground, LogoWrapper };
